export default __webpack_public_path__ + "static/media/icts-logo.d05971a4.svg";